module.exports = __webpack_public_path__ + "img/speedykeyboardkid.1cbcde08.png";